import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerkeerdGebruik = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8C9E9"
      fillRule="evenodd"
      d="m9.06 15.58 7.96-5.03-4.07-2.7-8.95 6v15h5.06z"
      clipRule="evenodd"
    />
    <path
      fill="#F29FC5"
      fillRule="evenodd"
      d="M10.06 16.13 20 9.85l10.06 6.28v15.72h-20z"
      clipRule="evenodd"
    />
    <path
      fill="#F8C9E9"
      d="m30.56 34.29-3.98-3.99c2.09-3.08 1.81-7.29-.86-10.05-2.99-3.09-8.09-3.21-11.21-.25-3.28 3.11-3.33 8.29-.16 11.47a7.96 7.96 0 0 0 10.12.96l3.98 3.99c.58.59 1.53.59 2.12 0 .58-.59.58-1.53 0-2.12zm-14.81-4.24a6 6 0 0 1 0-8.48c2.34-2.34 6.13-2.34 8.46 0a6 6 0 0 1 0 8.48c-2.34 2.34-6.13 2.34-8.46 0"
    />
    <path
      fill="#F8C9E9"
      fillRule="evenodd"
      d="m26.95 7.85-3.99 2.67 8.1 5.06v13.27H36v-15z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerkeerdGebruik);

export default ForwardRef;
